import React from "react";
import { SovosHeroBanner, SovosHeroBannerStatus, SovosHeroBannerSubtitle, SovosIcon } from "mosaic-react";
import styles from "./HeroBanner.module.sass";
import { ErrorOutlineOutlined, Task } from "mosaic-react-icons";
import { useGlobalValue } from "../../state/GlobalProvider";
import { Link } from "react-router-dom";
import { createLink } from "../../utils";
import { useTheme } from "mosaic-react/styles";
const colors = {
  warning: "banner-container-warning",
  success: "banner-container-success"
};
const HeroBanner = args => {
  const {
    i18n,
    params,
    proxy
  } = useGlobalValue();
  const {
    title,
    summary,
    link
  } = args;
  const hasSummary = summary && summary.length > 0;
  if (hasSummary) {
    summary.sort(({
      severity: a
    }, {
      severity: b
    }) => b.localeCompare(a));
  }
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["banner-container"]} ${styles[hasSummary ? colors.warning : colors.success]}`
  }, /*#__PURE__*/React.createElement(SovosHeroBanner, {
    color: "transparent",
    className: `${styles["sovos-banner"]}`
  }, /*#__PURE__*/React.createElement(SovosHeroBannerSubtitle, {
    style: {
      margin: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement(SovosIcon, null, hasSummary ? /*#__PURE__*/React.createElement(ErrorOutlineOutlined, {
    style: {
      fill: "#072448"
    }
  }) : /*#__PURE__*/React.createElement(Task, {
    style: {
      fill: "#072448"
    }
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "8px",
      color: "#072448",
      fontSize: "18px"
    }
  }, title))), /*#__PURE__*/React.createElement(SovosHeroBannerStatus, {
    style: {
      margin: "auto",
      justifyContent: "flex-end"
    }
  }, hasSummary && /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "rgba(255, 255, 255, 0.80)",
      padding: "8px 16px",
      gap: "10px",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "row"
    }
  }, summary.map((s, id) => {
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      style: {
        gap: "24px"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: theme.palette.text.secondary
      }
    }, i18n`${s.severity}`), /*#__PURE__*/React.createElement("span", {
      style: {
        color: theme.palette.text.primary,
        fontWeight: 700,
        marginLeft: "4px"
      }
    }, s.count));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "16px"
    }
  }, link ? /*#__PURE__*/React.createElement(Link, {
    className: styles["action-button"],
    to: createLink(undefined, proxy, link, params)
  }, /*#__PURE__*/React.createElement("small", {
    style: {
      textTransform: "none",
      whiteSpace: "nowrap",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React.createElement("strong", null, hasSummary ? i18n`${link.name}` : i18n`Status OK`))) : /*#__PURE__*/React.createElement("small", {
    style: {
      textTransform: "none",
      whiteSpace: "nowrap",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React.createElement("strong", null, !hasSummary ? i18n`Status OK` : ""))))));
};
export default HeroBanner;